import React from 'react'

import { IconWarningDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

import { EMAIL_CAPTURE_I18N } from '../constants'

interface EmailCaptureErrorProps {
  error?: string
  className?: string
}

export const EmailCaptureError = ({
  error,
  className = '',
}: EmailCaptureErrorProps) => {
  const { t } = useTranslation(EMAIL_CAPTURE_I18N)

  return (
    <div className={`${className} d-flex align-items-center`}>
      <IconWarningDefault className='mc-icon--3 mc-text--error' />
      <p aria-live='assertive' className='mc-text--error mc-text-x-small'>
        {error || t('error')}
      </p>
    </div>
  )
}
